import React, { useState } from 'react';
import { TemplateListPanel } from './TemplateListPanel';
import { TemplateDetailsPanel } from './TemplateDetailsPanel';
import type { KrybotTemplate } from '../../../types/krybot';
import styles from './TemplateManagement.module.css';

interface TemplateManagerProps {
  onRefresh?: () => void;
}

export const TemplateManager: React.FC<TemplateManagerProps> = ({ onRefresh }) => {
  const [selectedTemplateId, setSelectedTemplateId] = useState<string | null>(null);
  const [isCreating, setIsCreating] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState<KrybotTemplate | null>(null);

  const handleSelectTemplate = (templateId: string | null) => {
    setSelectedTemplateId(templateId);
    setIsCreating(false);
  };

  const handleCreateNew = () => {
    setSelectedTemplateId(null);
    setIsCreating(true);
    setCurrentTemplate(null);
  };

  const handleSave = () => {
    setIsCreating(false);
    // If we just created a new template, select it
    if (currentTemplate) {
      setSelectedTemplateId(currentTemplate.id);
    }
    onRefresh?.();
  };

  const handleCancel = () => {
    setIsCreating(false);
    if (!currentTemplate) {
      setSelectedTemplateId(null);
    }
  };

  const handleTemplateChange = (template: KrybotTemplate | null) => {
    setCurrentTemplate(template);
    if (template && isCreating) {
      setSelectedTemplateId(template.id);
    }
  };

  return (
    <div className="template-manager">
      <div className="template-manager-container">
        <div className="template-manager-list-panel">
          <TemplateListPanel
            selectedTemplateId={selectedTemplateId}
            onSelectTemplate={handleSelectTemplate}
            onCreateNew={handleCreateNew}
            onRefresh={onRefresh}
          />
        </div>
        <div className="template-manager-details-panel">
          <TemplateDetailsPanel
            templateId={selectedTemplateId}
            isCreating={isCreating}
            onSave={handleSave}
            onCancel={handleCancel}
            onTemplateChange={handleTemplateChange}
          />
        </div>
      </div>
    </div>
  );
};

